import { render, staticRenderFns } from "./BorderBox13.vue?vue&type=template&id=1e200bf5"
import script from "./BorderBox13.vue?vue&type=script&lang=js"
export * from "./BorderBox13.vue?vue&type=script&lang=js"
import style0 from "./BorderBox13.vue?vue&type=style&index=0&id=1e200bf5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports